(function (window, angular, undefined) {
    angular.module('formApp')
        .directive('sessionModal', ['sessionService', '$state', function(sessionService, $state) {
            return {
                restrict: 'EA',
                scope: {},
                link: function ($scope, element, attr) {

                    var modalMain = document.getElementById('sessionModal'),
                    p = document.getElementById('skipnav'),
                    modal = document.querySelector('#sessionModal .modal-dialog'),
                    list = document.querySelectorAll('body > *:not(.modal)');    

                    swap();

                    function closeDialog(){
                        angular.element(modalMain).attr({'aria-hidden': 'true','tab-index': '-1','open': false}); 
                    }                     

                    function focusDialog(){  
                        angular.element(modalMain).attr({ 'aria-hidden': 'false','tab-index': '0','open': true});  

                        modal.focus();

                        modal.addEventListener('keydown', function(e) {
                            handleKeyDown(e);
                        });                                                                                                            
                    }

                     function handleKeyDown(e) {
                       var returnQuote = document.querySelector('#sessionModal .return-quote');

                        angular.element(returnQuote).on('keydown', function(e){
                            if ((e.which === 9 && !e.shiftKey)) {
                               e.preventDefault();
                               modal.focus();
                           }
                        });

                        angular.element(modal).on('keydown', function(e){
                            if ((e.which === 9 && e.shiftKey)) {
                                e.preventDefault();
                                returnQuote.focus();
                            }
                        }); 
                    }                  

                    function swap(){
                        p.parentNode.insertBefore(modalMain, p);
                    }                                              

                    $scope.$on('TIMEOUT.WARNING', function() {
                        focusDialog();
                        $scope.sessionWarning = true;
                        $scope.$apply();
                    }); 

                    $scope.$on('TIMEOUT.EMAIL', function() {
                        $scope.sessionTimedOut = true;
                        $scope.$apply();
                    });

                    $scope.continue = function() {
                        closeDialog();
                        sessionService.refresh();
                        $scope.sessionWarning = false;
                    };

                    $scope.reload = function () {
                        sessionService.restart();
                        $scope.sessionTimedOut = $scope.sessionWarning = false;
                        var env = window.location.hostname;
                        var eQuote = sessionStorage.getItem('eQuote');
                        if (eQuote) {
                            console.log("(eQuote T");
                            if (env !== 'quote-dev.petplan.co.uk') {
                                //
                                window.location.href = '/content/ah_small-animal/index.html/retrieve-quote';
                            }
                            else {
                                window.location.href = '/equote/retrieve-quote';
                            }

                        }
                        else {
                            console.log("no eQuote T");
                            $state.go('step-1', { forward: true });
                        }

                    };

                },
                templateUrl: 'directives/session-modal/templates/session-modal.html'
            };
        }]);
})(window, window.angular);